/* ================= AUTH ================= */
export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';
export const LOGOUT = 'auth/LOGOUT';

export const REGISTER_REQUEST = 'auth/REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'auth/REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'auth/REGISTER_FAILURE';

export const GET_PROFILE_REQUEST = 'auth/GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'auth/GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'auth/GET_PROFILE_FAILURE';


/* ================= CMS ================= */
export const FETCH_CMS_REQUEST = 'cms/FETCH_CMS_REQUEST';
export const FETCH_CMS_SUCCESS = 'cms/FETCH_CMS_SUCCESS';
export const FETCH_CMS_FAILURE = 'cms/FETCH_CMS_FAILURE';

export const ADD_CMS_REQUEST = 'cms/ADD_CMS_REQUEST';
export const ADD_CMS_SUCCESS = 'cms/ADD_CMS_SUCCESS';
export const ADD_CMS_FAILURE = 'cms/ADD_CMS_FAILURE';

export const UPDATE_CMS_REQUEST = 'cms/UPDATE_CMS_REQUEST';
export const UPDATE_CMS_SUCCESS = 'cms/UPDATE_CMS_SUCCESS';
export const UPDATE_CMS_FAILURE = 'cms/UPDATE_CMS_FAILURE';

export const DELETE_CMS_REQUEST = 'cms/DELETE_CMS_REQUEST';
export const DELETE_CMS_SUCCESS = 'cms/DELETE_CMS_SUCCESS';
export const DELETE_CMS_FAILURE = 'cms/DELETE_CMS_FAILURE';

export const DELETE_MODEL_REQUEST = 'cms/DELETE_MODEL_REQUEST';
export const DELETE_MODEL_SUCCESS = 'cms/DELETE_MODEL_SUCCESS';
export const DELETE_MODEL_FAILURE = 'cms/DELETE_MODEL_FAILURE';

export const UPLOADCMSIMAGE_CMS_REQUEST = 'cms/UPLOADCMSIMAGE_REQUEST';
export const UPLOADCMSIMAGE_CMS_SUCCESS = 'cms/UPLOADCMSIMAGE_SUCCESS';
export const UPLOADCMSIMAGE_CMS_FAILURE = 'cms/UPLOADCMSIMAGE_FAILURE';
export const SET_MERCHANT_STATUS = 'cms/SET_MERCHANT_STATUS'

/* ================= MERCHANT ================= */
export const CREATE_MERCHANT_REQUEST = 'merchant/CREATE_MERCHANT_REQUEST';
export const CREATE_MERCHANT_SUCCESS = 'merchant/CREATE_MERCHANT_SUCCESS';
export const CREATE_MERCHANT_FAILURE = 'merchant/CREATE_MERCHANT_FAILURE';

export const CREATE_COUPON_REQUEST = 'merchant/CREATE_COUPON_REQUEST';
export const CREATE_COUPON_SUCCESS = 'merchant/CREATE_COUPON_SUCCESS';
export const CREATE_COUPON_FAILURE = 'merchant/CREATE_COUPON_FAILURE';

export const DELETE_COUPON_REQUEST = "DELETE_COUPON_REQUEST";
export const DELETE_COUPON_SUCCESS = "DELETE_COUPON_SUCCESS";
export const DELETE_COUPON_FAILURE = "DELETE_COUPON_FAILURE";

export const GET_COUPON_REQUEST = 'merchant/GET_COUPON_REQUEST';
export const GET_COUPON_SUCCESS = 'merchant/GET_COUPON_SUCCESS';
export const GET_COUPON_FAILURE = 'merchant/GET_COUPON_FAILURE';

export const SAVE_LOYALTY_SETTINGS_REQUEST = "SAVE_LOYALTY_SETTINGS_REQUEST";
export const SAVE_LOYALTY_SETTINGS_SUCCESS = "SAVE_LOYALTY_SETTINGS_SUCCESS";
export const SAVE_LOYALTY_SETTINGS_FAILURE = "SAVE_LOYALTY_SETTINGS_FAILURE";

export const GET_LOYALTY_SETTINGS_REQUEST = "GET_LOYALTY_SETTINGS_REQUEST";
export const GET_LOYALTY_SETTINGS_SUCCESS = "GET_LOYALTY_SETTINGS_SUCCESS";
export const GET_LOYALTY_SETTINGS_FAILURE = "GET_LOYALTY_SETTINGS_FAILURE";

export const COPY_CMS_REQUEST = "COPY_CMS_REQUEST";
export const COPY_CMS_SUCCESS = "COPY_CMS_SUCCESS";
export const COPY_CMS_FAILURE = "COPY_CMS_FAILURE";


export const MERCHANT_LOGIN_REQUEST = 'merchant/LOGIN_REQUEST';
export const MERCHANT_LOGIN_SUCCESS = 'merchant/LOGIN_SUCCESS';
export const MERCHANT_LOGIN_FAILURE = 'merchant/LOGIN_FAILURE';

export const GET_MERCHANT_REQUEST = 'merchant/GET_REQUEST';
export const GET_MERCHANT_SUCCESS = 'merchant/GET_SUCCESS';
export const GET_MERCHANT_FAILURE = 'merchant/GET_FAILURE';

export const UPDATE_MERCHANT_REQUEST = 'merchant/UPDATE_REQUEST';
export const UPDATE_MERCHANT_SUCCESS = 'merchant/UPDATE_SUCCESS';
export const UPDATE_MERCHANT_FAILURE = 'merchant/UPDATE_FAILURE';


/* ================= CATALOG MODELS ================= */
export const GET_CATALOG_MODELS_REQUEST = 'catalog/GET_MODELS_REQUEST';
export const GET_CATALOG_MODELS_SUCCESS = 'catalog/GET_MODELS_SUCCESS';
export const GET_CATALOG_MODELS_FAILURE = 'catalog/GET_MODELS_FAILURE';

export const CREATE_CATALOG_MODEL_REQUEST = 'catalog/CREATE_MODEL_REQUEST';
export const CREATE_CATALOG_MODEL_SUCCESS = 'catalog/CREATE_MODEL_SUCCESS';
export const CREATE_CATALOG_MODEL_FAILURE = 'catalog/CREATE_MODEL_FAILURE';

export const UPDATE_CATALOG_MODEL_REQUEST = 'catalog/UPDATE_MODEL_REQUEST';
export const UPDATE_CATALOG_MODEL_SUCCESS = 'catalog/UPDATE_MODEL_SUCCESS';
export const UPDATE_CATALOG_MODEL_FAILURE = 'catalog/UPDATE_MODEL_FAILURE';

export const DELETE_CATALOG_MODEL_REQUEST = 'catalog/DELETE_MODEL_REQUEST';
export const DELETE_CATALOG_MODEL_SUCCESS = 'catalog/DELETE_MODEL_SUCCESS';
export const DELETE_CATALOG_MODEL_FAILURE = 'catalog/DELETE_MODEL_FAILURE';


/* ================= CATALOG ITEMS ================= */
export const GET_CATALOG_ITEMS_REQUEST = 'catalog/GET_ITEMS_REQUEST';
export const GET_CATALOG_ITEMS_SUCCESS = 'catalog/GET_ITEMS_SUCCESS';
export const GET_CATALOG_ITEMS_FAILURE = 'catalog/GET_ITEMS_FAILURE';

export const CREATE_CATALOG_ITEM_REQUEST = 'catalog/CREATE_ITEM_REQUEST';
export const CREATE_CATALOG_ITEM_SUCCESS = 'catalog/CREATE_ITEM_SUCCESS';
export const CREATE_CATALOG_ITEM_FAILURE = 'catalog/CREATE_ITEM_FAILURE';

export const UPDATE_CATALOG_ITEM_REQUEST = 'catalog/UPDATE_ITEM_REQUEST';
export const UPDATE_CATALOG_ITEM_SUCCESS = 'catalog/UPDATE_ITEM_SUCCESS';
export const UPDATE_CATALOG_ITEM_FAILURE = 'catalog/UPDATE_ITEM_FAILURE';

export const UPDATE_CATALOG_ITEM_STATUS_REQUEST = 'catalog/UPDATE_ITEM_STATUS_REQUEST';
export const UPDATE_CATALOG_ITEM_STATUS_SUCCESS = 'catalog/UPDATE_ITEM_STATUS_SUCCESS';
export const UPDATE_CATALOG_ITEM_STATUS_FAILURE = 'catalog/UPDATE_ITEM_STATUS_FAILURE';

export const CREATE_ITEM_VARIENT_REQUEST = 'catalog/CREATE_ITEM_VARIENT_REQUEST';
export const CREATE_ITEM_VARIENT_SUCCESS = 'catalog/CREATE_ITEM_VARIENT_SUCCESS';
export const CREATE_ITEM_VARIENT_FAILURE = 'catalog/CREATE_ITEM_VARIENT_FAILURE';

export const GET_ITEMS_VARIANTS_REQUEST = 'catalog/GET_ITEMS_VARIANTS_REQUEST';
export const GET_ITEMS_VARIANTS_SUCCESS = 'catalog/GET_ITEMS_VARIANTS_SUCCESS';
export const GET_ITEMS_VARIANTS_FAILURE = 'catalog/GET_ITEMS_VARIANTS_FAILURE';

export const SET_GET_ITEMS_VARIANTS = 'catalog/SET_GET_ITEMS_VARIANTS';

export const DELETE_CATALOG_ITEMS_REQUEST = 'catalog/DELETE_CATALOG_ITEMS_REQUEST';
export const DELETE_CATALOG_ITEMS_SUCCESS = 'catalog/DELETE_CATALOG_ITEMS_SUCCESS';
export const DELETE_CATALOG_ITEMS_FAILURE = 'catalog/DELETE_CATALOG_ITEMS_FAILURE';

export const UPDATE_ITEM_VARIANT_REQUEST = 'catalog/UPDATE_ITEM_VARIANT_REQUEST';
export const UPDATE_ITEM_VARIANT_SUCCESS = 'catalog/UPDATE_ITEM_VARIANT_SUCCESS';
export const UPDATE_ITEM_VARIANT_FAILURE = 'catalog/UPDATE_ITEM_VARIANT_FAILURE';

/* ================= POSTS ================= */
export const FETCH_POSTS_REQUEST = 'posts/FETCH_REQUEST';
export const FETCH_POSTS_SUCCESS = 'posts/FETCH_SUCCESS';
export const FETCH_POSTS_FAILURE = 'posts/FETCH_FAILURE';

export const CREATE_POST_REQUEST = 'posts/CREATE_REQUEST';
export const CREATE_POST_SUCCESS = 'posts/CREATE_SUCCESS';
export const CREATE_POST_FAILURE = 'posts/CREATE_FAILURE';

export const UPDATE_POST_REQUEST = 'posts/UPDATE_REQUEST';
export const UPDATE_POST_SUCCESS = 'posts/UPDATE_SUCCESS';
export const UPDATE_POST_FAILURE = 'posts/UPDATE_FAILURE';

export const DELETE_POST_REQUEST = 'posts/DELETE_REQUEST';
export const DELETE_POST_SUCCESS = 'posts/DELETE_SUCCESS';
export const DELETE_POST_FAILURE = 'posts/DELETE_FAILURE';


/* ================= MEDIA ================= */
export const FETCH_MEDIA_REQUEST = 'media/FETCH_REQUEST';
export const FETCH_MEDIA_SUCCESS = 'media/FETCH_SUCCESS';
export const FETCH_MEDIA_FAILURE = 'media/FETCH_FAILURE';

export const UPLOAD_MEDIA_REQUEST = 'media/UPLOAD_REQUEST';
export const UPLOAD_MEDIA_SUCCESS = 'media/UPLOAD_SUCCESS';
export const UPLOAD_MEDIA_FAILURE = 'media/UPLOAD_FAILURE';

export const DELETE_MEDIA_REQUEST = 'media/DELETE_REQUEST';
export const DELETE_MEDIA_SUCCESS = 'media/DELETE_SUCCESS';
export const DELETE_MEDIA_FAILURE = 'media/DELETE_FAILURE';


/* ================= USERS ================= */
export const FETCH_USERS_REQUEST = 'users/FETCH_REQUEST';
export const FETCH_USERS_SUCCESS = 'users/FETCH_SUCCESS';
export const FETCH_USERS_FAILURE = 'users/FETCH_FAILURE';

export const CREATE_USER_REQUEST = 'users/CREATE_REQUEST';
export const CREATE_USER_SUCCESS = 'users/CREATE_SUCCESS';
export const CREATE_USER_FAILURE = 'users/CREATE_FAILURE';

export const UPDATE_USER_REQUEST = 'users/UPDATE_REQUEST';
export const UPDATE_USER_SUCCESS = 'users/UPDATE_SUCCESS';
export const UPDATE_USER_FAILURE = 'users/UPDATE_FAILURE';

export const DELETE_USER_REQUEST = 'users/DELETE_REQUEST';
export const DELETE_USER_SUCCESS = 'users/DELETE_SUCCESS';
export const DELETE_USER_FAILURE = 'users/DELETE_FAILURE';
